import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { handleOpenLocation } from 'shared/slice/MCIsExpandedSlice';
import { justifyContentSpaceBetween, layerA } from 'shared/styles/commonStyles';
import { getHpStationName } from 'features/heatingPlatform/components/stationsData';



const HpStationLocation = ({ station, index, isExpanded }) => {
  const dispatch = useDispatch();
  const [src, setSrc] = useState('/images/IS-arrow.svg');

  useEffect(() => {
    setSrc(
      isExpanded ? '/images/IS-arrow-expanded.svg' : '/images/IS-arrow.svg',
    );
  }, [isExpanded]);

  const handleExpand = () => {
    dispatch(
      handleOpenLocation({ swtName: 'hp', index, status: !isExpanded }),
    );
  };

  return (
    <>
      <Wrapper>
        <IconAndLocationWrapper>
          <Icon onClick={handleExpand} src={src} />
          <Info>{getHpStationName(station)}</Info>
        </IconAndLocationWrapper>
        <Info>{station.segmentTitles.length} segments</Info>
        <Info>-- Hrs</Info>
        <Info>-- kw</Info>
      </Wrapper>
      {isExpanded &&
        station.segmentTitles.map((title, idx) => (
          <SegmentWrapper key={idx}>
            <IconAndLocationWrapper>
              <SegmentIcon src='/images/indeMachine-icon.svg' />
              <SegmentInfo>
                {station.stationTitle} - {title}
              </SegmentInfo>
            </IconAndLocationWrapper>
            <SegmentInfo>1 segment</SegmentInfo>
            <SegmentInfo>-- Hrs</SegmentInfo>
            <SegmentInfo>-- kw</SegmentInfo>
          </SegmentWrapper>
        ))}
    </>
  );
};

export default HpStationLocation;

const Wrapper = styled.div`
  width: 99.6%;
  min-height: 16px;
  border-radius: 13px;

  border: 1px solid #233a54;

  ${justifyContentSpaceBetween}
  padding: 0 8rem;
  margin-bottom: 2rem;

  :last-child {
    margin-bottom: 0;
  }
  :hover {
    ${layerA}
  }
`;

const SegmentWrapper = styled(Wrapper)`
  padding: 0 8rem 0 22rem;
`;

const IconAndLocationWrapper = styled.div`
  width: 40%;
  display: flex;
  align-items: center;
`;

const Icon = styled.img`
  margin-right: 4rem;
  cursor: pointer;
`;

const SegmentIcon = styled.img`
  margin-right: 4rem;
`;

const Info = styled.span`
  font-size: 8rem;
`;

const SegmentInfo = styled.span`
  font-size: 7rem;
`;
